var COLORS, ReportChart;

COLORS = [
  'rgba(255, 152, 0, .8)',
  'rgba(255, 193, 7, .8)',
  'rgba(124, 214, 63, .8)',
  'rgba(33, 150, 243, .8)',
  'rgba(63, 81, 181, .8)',
  'rgba(244, 67, 54, .8)'
];

export default ReportChart = Vue.extend({
  props: {
    chartData: {
      type: Object,
      default: null
    },
    chartType: {
      type: String,
      default: 'bar'
    },
    chartOptions: {
      type: Object,
      default: null
    }
  },

  data: function() {
    return {
      chart: null
    };
  },

  template: `
    <canvas ref="canvas"></canvas>
  `,

  computed: {
    ctx: function() {
      var ref;

      return (ref = this.chart) != null ? ref.ctx : void 0;
    },

    repeatColors: function() {
      return _.map(this.chartData.labels, function(item, index) {
        return COLORS[index % COLORS.length];
      });
    },

    computedChartOptions: function() {
      return _.extend({}, this.chartOptions, {
        animation: {
          onComplete: () => {
            switch (this.chartType) {
              case 'bar':
                return this._showBarValue(0, 5);
              case 'horizontalBar':
                return this._showBarValue(-25, -7);
              case 'pie':
                return this._showPieValue();
            }
          }
        }
      });
    }
  },

  watch: {
    chartData: function() {
      this.chart.data.datasets[0].data = this.chartData.data;
      return this.chart.update();
    },

    chartType: function() {
      return this.drawChart();
    }
  },

  mounted: function() {
    return this.drawChart();
  },

  methods: {
    drawChart: function() {
      var ctx, ref;

      if ((ref = this.chart) != null) {
        ref.destroy();
      }

      ctx = this.$refs.canvas.getContext('2d');
      return this.chart = new Chart(ctx, {
        type: this.chartType,
        data: {
          labels: this.chartData.labels,
          datasets: [
            {
              data: this.chartData.data,
              backgroundColor: this.repeatColors
            }
          ]
        },
        options: this.computedChartOptions
      });
    },

    _showBarValue: function(positionX, positionY) {
      var dataset, meta;

      this.ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, '500', Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
      this.ctx.textAlign = 'center';
      this.ctx.textBaseline = 'bottom';

      dataset = this.chart.data.datasets[0];
      meta = this.chart.getDatasetMeta(0);
      return _.each(meta.data, (bar, index) => {
        var data;

        data = dataset.data[index];
        return this.ctx.fillText(data + '%', bar._model.x - positionX, bar._model.y - positionY);
      });
    },

    _showPieValue: function() {
      var dataset, meta, tempAngle;

      this.ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, '500', Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
      this.ctx.textAlign = 'center';
      this.ctx.fillStyle = '#313131';

      dataset = this.chart.data.datasets[0];
      meta = this.chart.getDatasetMeta(0);

      tempAngle = (Number(meta.data[0]._model.startAngle) / (2 * Math.PI)) * 360;

      return _.each(meta.data, (pie, index) => {
        var angle, data, label, txtAngle, txtWidth, x, y;

        angle = (Number(pie._model.endAngle - pie._model.startAngle) / (2 * Math.PI)) * 360;

        data = dataset.data[index];
        label = this.chartData.labels[index];
        txtAngle = tempAngle + 1 / 2 * angle;

        txtWidth = label.length * 12;
        x = pie._model.x + Math.cos(txtAngle * Math.PI / 180) * (pie._model.outerRadius + 20 + txtWidth);
        y = pie._model.y + Math.sin(txtAngle * Math.PI / 180) * (pie._model.outerRadius + 20);

        if (data > 0) {
          this.ctx.fillText(label + ' ' + data + '%', x, y);
        }
        return tempAngle += angle;
      });
    }
  }
});
